module.exports = __webpack_public_path__ + "static/media/FinancialServices.f3952735.svg";